import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import HowToOrderMobile from 'components/_special/HowToOrderMobile'
import SectionWrapper from 'components/SectionWrapper'
import { RU } from 'constants/countries'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'

import BHowOrderEuroBox from './components/BHowOrderEuroBox'
import BHowOrderRussianBox from './components/BHowOrderRussianBox'

const MOBILE_IMAGES_EU = ['box', 'brochure', 'container', 'instruction']

const MOBILE_IMAGES_RU = [
  'list_circle',
  'list_container_new',
  'list_instruction_new',
  'list_tube_new',
]

/**
 * BHowOrder
 *
 * @param {object} props - properties of component
 * @returns {node} BHowOrder
 */
const BHowOrder = ({ data, pathCdn, index, isSquareHidden }) => {
  const { locale, paths } = useContext(LocalizationContext)
  const { mobile } = useContext(ResizeContext)
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapper isOverflowHidden={true}>
      {mobile ? (
        <HowToOrderMobile
          {...{ pathCdn }}
          descriptions={data.slider.list}
          images={locale === RU ? MOBILE_IMAGES_RU : MOBILE_IMAGES_EU}
          title={data.title}
          index={index}
          squareColor={colors.grass}
        />
      ) : (
        <HowToBlock
          {...{ isSquareHidden, index }}
          title={data.title}
          isFirst={true}
          squareColor={colors.grass}
        >
          {locale === RU ? (
            <BHowOrderRussianBox
              {...{ path: `${paths.cdn_global}/boxes`, data }}
            />
          ) : (
            <BHowOrderEuroBox
              {...{ path: `${paths.cdn_global}/boxes`, data }}
            />
          )}
        </HowToBlock>
      )}
    </SectionWrapper>
  )
}

BHowOrder.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  pathCdn: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
  locale: PropTypes.string,
}

BHowOrder.defaultProps = {
  isSquareHidden: false,
}

export default BHowOrder
